// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"a4bb65c7","255":"0c890044","348":"d8c3a72e","584":"10e3b223","731":"47f99b3a","766":"51a259a3","834":"035df147","858":"8edc8477","937":"d17204e9"}[chunkId] + ".chunk.js";
};